import { styled as muiStyled } from '@mui/material/styles';
import { Box, Dialog, DialogActions } from "@mui/material";
import { error } from 'styles/theme';

const WrapDialogActions = muiStyled(DialogActions)(({ theme }) => ({
    justifyContent: 'flex-end',
    padding: "0px 24px 24px 24px"
}));

const AlertContentStyles = muiStyled(Box)(({ }) => ({
    width: "100%",
    height: "100%",
    '.img-preview': {
        width: "100%",
        height: "100%",
    }
}));

const WrapDialog = muiStyled(Dialog)(({ size, bg, fullScreen, type, theme, $systemUI }) => ({
    overflow: "hidden",
    '.MuiPaper-root.MuiDialog-paper': {
        maxHeight: size?.height ? size?.height : fullScreen && 600,
        maxWidth: size?.width ? size?.width : fullScreen && 1124,
        background: bg
    },
    '.full-screen-title': {
        padding: "5px 0px 0px 5px"
    },
    '.dialog-title': {
        color: type == "danger" && error,
        fontWeight: 700,
        fontSize: 22
    },
    '.MuiPaper-root': {
        borderRadius: 15,
        overflow: "hidden",
    },
    '.MuiDialogContent-root': {
        paddingTop: '3px !important',
        padding: fullScreen && "0px !important",
        overflow: fullScreen && "hidden !important"
    }
}));

export { AlertContentStyles, WrapDialogActions, WrapDialog }